var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMpReasonsStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1483 2.26594C20.7883 0.578019 23.2102 0.578019 23.8522 2.26594L27.992 13.7334C28.1364 14.107 28.3907 14.428 28.7214 14.654C29.052 14.88 29.4434 15.0004 29.8439 14.9994H40.0174C41.8974 14.9994 42.7173 17.3393 41.2394 18.4852L33.9997 24.9989C33.6754 25.2482 33.4384 25.5939 33.3227 25.9862C33.207 26.3786 33.2186 26.7975 33.3557 27.1828L35.9996 38.3883C36.6436 40.1883 34.5597 41.7342 32.9838 40.6262L23.1502 34.3865C22.8134 34.1498 22.4119 34.0228 22.0002 34.0228C21.5886 34.0228 21.1871 34.1498 20.8503 34.3865L11.0167 40.6262C9.4428 41.7342 7.35689 40.1863 8.00086 38.3883L10.6447 27.1828C10.7819 26.7975 10.7935 26.3786 10.6778 25.9862C10.5621 25.5939 10.3251 25.2482 10.0008 24.9989L2.7611 18.4852C1.28116 17.3393 2.10512 14.9994 3.98104 14.9994H14.1546C14.5552 15.0007 14.9467 14.8804 15.2774 14.6543C15.6081 14.4283 15.8623 14.1072 16.0065 13.7334L20.1463 2.26594H20.1483Z",
    stroke: "#02E2FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpReasonsStar);
export default __webpack_public_path__ + "static/media/mp-reasons-star.fd9234081cc13da30f81ce83685d1c5e.svg";
export { ForwardRef as ReactComponent };